import { useRef} from "react"
import { useDispatch, useSelector } from "react-redux";
import PageGridAlt from "../Components/PageGridAlt";
import useFetch from "../Hooks/useFetch";
import {GrCaretNext, GrCaretPrevious} from 'react-icons/gr';
import { useState } from "react";

const SearchPage = ()=>{
    const input = useRef();
    const dispatch = useDispatch();
    const category = useSelector(state=>state.CategoryReducer);
    const key = process.env.REACT_APP_API_KEY;
    const value = useSelector(state=>state.SearchValue);
    const [page,setPage] = useState(1);
    const {results:movies}= useFetch(`https://api.themoviedb.org/3/search/${(category)?'movie':'tv'}?api_key=${key}&language=en-US&query=${value}&page=${page}&include_adult=false`)
    const handleSearch = ()=>{
       dispatch({type:'SEARCH',payload:input.current.value});
    }

    const handleCategory = (e)=>{
        console.log(e.target.innerText);
        if(e.target.innerText==='Movies'){
            dispatch({type:'MOVIE'});
        }
        else{
            dispatch({type:'TV SHOW'});
        }
    }

    const handlePage = (e)=>{
        if(e.target.innerText==='Next'){
            setPage(state=>state+1);
        }
        else{
            if(page===1){
                setPage(1);
            }
            setPage(state=>state-1);
        }
    }

    return <div className=" flex flex-col   dark:bg-secondary-dark min-h-screen pt-16 pb-2  ">
        <span className="text-headline dark:text-headline-dark font-heading bg-background dark:bg-background-dark shadow-md p-4 max-w-fit text-sm lg:text-lg md:text-md self-center">
            <input type={'text'} placeholder='Search for something' className=" shadow-inner md:w-[25vw] w-[50vw] p-2 border-[1px] border-tertiary outline-none dark:bg-secondary-dark" ref={input}/>
            <button className="bg-button dark:bg-button-dark text-button-text  py-2 px-4" onClick={handleSearch}>Search</button>
        </span>
        <span className="flex flex-row justify-center mt-4 text-headline dark:text-headline-dark font-heading">
            <button className={`md:px-8 px-4 ${(category)?'border-2 border-button':null}  mr-1`} onClick={handleCategory}>Movies</button>
            <button className={`ml-1 md:px-8 px-4 ${(!category)?'border-2 border-button':null}` } onClick={handleCategory}>Tv Shows</button>
        </span>
        <h1 className="lg:text-xl md:text-lg text-md text-headline font-heading dark:text-headline-dark lg:px-8 md-px-4 px-2 md:mt-4 mt-2">Search Results of: {value}</h1>
       <PageGridAlt data={movies}/>
       <section className='flex flex-row justify-center lg:text-lg md:text-md text-sm text-button-text mt-4'>
            <button className='bg-button dark:bg-button-dark mr-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}><GrCaretPrevious/>Prev</button>
            <button className='bg-button dark:bg-button-dark ml-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}>Next<GrCaretNext/></button>
        </section>
    </div>
}

export default SearchPage